import React from "react";
import { IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  return (
    <IconButton onClick={() => navigate(-1)} aria-label="Back" size="small">
      <ArrowBackIcon sx={{ fontSize: 18 }} />
    </IconButton>
  );
};

export default BackButton;
